import React, { FC } from "react";
import NotificationIndicator, {
  ControlledProps,
} from "../NotificationIndicator";
import { useNotificationsForModule } from "../../../../store/notifications/useSelectors";
import { useTheme } from "../../../../config/emotion";

const ModuleContainer: FC<Props> = ({ moduleId, ...rest }) => {
  const moduleNotifications = useNotificationsForModule(moduleId);
  const bgColor = useTheme().colors.delete;

  return (
    <NotificationIndicator
      {...rest}
      notificationCount={moduleNotifications.length}
      backgroundColor={bgColor}
    />
  );
};

export type Props = Pick<
  ControlledProps,
  "onClick" | "className" | "displayWhenZero"
> & {
  moduleId: number;
};

export default ModuleContainer;
export type ContainerProps = Props;
